module.exports = __webpack_public_path__ + "static/phi-b27de9e6c65bb4280d5779ae47c5c3b1.png";